"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatternService = void 0;
var DateTimeCheckService_1 = __importDefault(require("../DateTimeCheckService"));
var lodash_isequal_1 = __importDefault(require("lodash.isequal"));
var PatternService = (function () {
    function PatternService(_a) {
        var lastTime = _a.lastTime, blocksPattern = _a.blocksPattern, blockIndex = _a.blockIndex, streamBlockPattern = _a.streamBlockPattern, allBlocks = _a.allBlocks;
        var _this = this;
        this.blocksPattern = [];
        this.tagPatterns = {};
        this.streamBlockPattern = streamBlockPattern;
        this.allBlocks = allBlocks;
        if (lastTime && blockIndex !== undefined && blocksPattern && lastTime) {
            this.restorePatterns(lastTime, blocksPattern, blockIndex);
        }
        this.allBlocks.forEach(function (block) {
            _this.tagPatterns[block.id] = {
                blockId: block.id,
                pattern: block.pattern,
                index: 0,
            };
        });
    }
    PatternService.prototype.restorePatterns = function (lastTime, blocksPattern, blockIndex) {
        this.calculateNextPatterns(lastTime);
        var patterns = this.getPatterns();
        if ((0, lodash_isequal_1.default)(blocksPattern, patterns.blocksPattern)) {
            this.blockIndex = blockIndex;
        }
        else {
            this.blockIndex = undefined;
            this.blocksPattern = [];
        }
    };
    PatternService.prototype.calculateBlockPattern = function (blocks, isSpecialBlocks) {
        if (isSpecialBlocks === void 0) { isSpecialBlocks = false; }
        var blockIds = blocks.map(function (block) { return block.id; });
        var blocksPattern = [];
        if (!this.streamBlockPattern.length ||
            (this.streamBlockPattern.length === 1 && !this.streamBlockPattern[0].length)) {
            blocksPattern.push.apply(blocksPattern, __spreadArray([], __read(blockIds.map(function (blockId) { return [blockId]; })), false));
            return blocksPattern;
        }
        this.streamBlockPattern.forEach(function (blockPattern) {
            var pattern = [];
            blockPattern.forEach(function (block) {
                if (blockIds.includes(block))
                    pattern.push(block);
            });
            if (pattern.length)
                blocksPattern.push(pattern);
        });
        if (!blocksPattern.length) {
            var pattern = blocks.map(function (block) { return block.id; });
            if (pattern.length)
                blocksPattern.push(pattern);
        }
        return blocksPattern;
    };
    PatternService.prototype.calculatePatterns = function (time) {
        var filteredBlocks = this.allBlocks.filter(function (block) {
            return DateTimeCheckService_1.default.checkNextTimeForObject(block, time);
        });
        var specialBlocks = filteredBlocks.filter(function (block) { return block.isSpecial; });
        var calculatedBlockPatterns;
        if (specialBlocks.length) {
            calculatedBlockPatterns = this.calculateBlockPattern(specialBlocks, true);
        }
        else {
            calculatedBlockPatterns = this.calculateBlockPattern(filteredBlocks);
        }
        if (!(0, lodash_isequal_1.default)(this.blocksPattern, calculatedBlockPatterns)) {
            this.blocksPattern = calculatedBlockPatterns;
            this.blockIndex = 0;
        }
    };
    PatternService.prototype.getBlockIds = function () {
        if (!this.blocksPattern.length || this.blockIndex === undefined)
            return [];
        return this.blocksPattern[this.blockIndex] || [];
    };
    PatternService.prototype.incrementBlockIndex = function () {
        if (this.blockIndex === undefined || this.blockIndex + 1 >= this.blocksPattern.length) {
            this.blockIndex = 0;
        }
        else {
            this.blockIndex += 1;
        }
    };
    PatternService.prototype.incrementTagIndex = function (blockId) {
        if (!blockId)
            return;
        var tagPattern = this.tagPatterns[blockId];
        if (!tagPattern)
            return;
        tagPattern.index += 1;
        if (tagPattern.index >= tagPattern.pattern.length)
            tagPattern.index = 0;
    };
    PatternService.prototype.getPatterns = function () {
        return {
            blocksPattern: this.blocksPattern,
            blockIndex: this.blockIndex,
            blockIds: this.getBlockIds(),
            tagPatterns: this.tagPatterns,
        };
    };
    PatternService.prototype.calculateNextPatterns = function (time) {
        this.incrementBlockIndex();
        this.calculatePatterns(time);
    };
    return PatternService;
}());
exports.PatternService = PatternService;
//# sourceMappingURL=PatternService.js.map